import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { APP_QUERY_KEYS } from '@/lib/constants/app';
import { AppApi } from './AppApi';
import type { AppCfgFilesDto } from '@/lib/types/App';

export function useApps() {
  const { selectedCId } = useAuth();

  const query = useQuery({
    queryKey: APP_QUERY_KEYS.list(selectedCId ?? 0),
    queryFn: () => AppApi.getApps(selectedCId!).then((r) => r.data),
    enabled: selectedCId != null,
    staleTime: 2 * 60_000,
    gcTime: 10 * 60_000,
  });

  const apps: AppCfgFilesDto[] = query.data ?? [];

  return { apps, ...query };
}
